import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ProjetoProduto } from '../../../models/projeto-produto.model';
import { ProjetoProdutoService } from '../../../services/projeto-produto.service';
import { environment } from 'src/environments/environment';
import { ProjetoCadastroService } from '../../../services/projeto-cadastro.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-projeto-produto-list',
  templateUrl: './projeto-produto-list.component.html',
  styleUrls: ['./projeto-produto-list.component.scss'],
})
export class ProjetoProdutoListComponent
  extends BaseListComponent<ProjetoProduto>
  implements OnInit, OnDestroy
{
  idProjeto: number;
  infoProjeto: any;
  total: any;
  permission: any;
  produtoList: ProjetoProduto[];
  modalCloneRef?: BsModalRef;
  clone_title: string;

  @ViewChild('modalClone') modalClone: TemplateRef<any>;

  constructor(
    private myService: ProjetoProdutoService,
    private projetoService: ProjetoCadastroService,
    public activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.idProjeto = this.activatedRoute.parent.snapshot.params?.id;
    this.initList();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    if (this.idProjeto) {
      this.addSub(
        this.myService.getListAll(this.idProjeto).subscribe({
          next: (res) => {
            this.produtoList = res?.['list'];
            this.total = res?.['total'];
            this.infoProjeto = res?.['infoProjeto'];
            this.permission = res?.['permission'];
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error);
            this.loaded();
          },
        })
      );
    }
  }

  voltar() {
    this.navigation.back(['/pre-projeto', 'projeto']);
  }

  novo() {
    return ['/pre-projeto', 'projeto', 'produtos', this.idProjeto, 'adicionar'];
  }

  editar(id: number) {
    return ['/pre-projeto', 'projeto', 'produtos', id];
  }

  confirmExcluir() {
    this.alertConfirmation(null, 'Tem certeza que deseja excluir o projeto?').subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.projetoService.delete(this.idProjeto).subscribe({
      next: () => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/pre-projeto', 'projeto']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error);
      },
    });
  }

  closeCloneModal() {
    this.modalCloneRef?.hide();
  }

  openCloneModal() {
    this.clone_title = '';
    this.modalCloneRef = this.modalService.show(this.modalClone);
  }

  clonar() {
    this.closeCloneModal();
    this.loading();
    if (this.idProjeto && this.permission.can_clone) {
      const obj = {
        clone_id: this.idProjeto,
        clone_title: this.clone_title,
      };
      this.addSub(
        this.projetoService.clonar(obj).subscribe({
          next: () => {
            this.msgSuccess('Clonado com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  imprimir() {
    this.loading();
    const url = `${environment.serverUrl}/rest/pre-projeto/relatorio/${this.idProjeto}`;
    this.loaded();
    window.open(url, '_blank');
  }
}